import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NotificationService } from '../../../../../../src/app/notification.service';
import * as commonConstant from '../../../../../../src/app/services/common.constant';
import * as CommonFunction from '../../../../services/common.function';
import { NgxSpinnerService } from "ngx-spinner";
import { ClientService } from '../../../../services/Client/client.service';
import { DatatransferService } from 'src/app/services/DataTransfer/datatransfer.service';
import { Addeditclient } from 'src/app/models/client/addeditclient.model';

@Component({
  selector: 'app-viewclient',
  templateUrl: './viewclient.component.html',
  styleUrls: ['./viewclient.component.css']
})
export class ViewclientComponent implements OnInit {
  public addEditClient: Addeditclient = new Addeditclient;
  monitoringFrequency ?: string;
  paymentProfile ?: string;
  submitted = false;
  arrPaymentProfile: any[] = [];
  clientResponse: any;
  listingBodyParameter: any;
  clientId: string;
  clientName: any;
  email: any;
  expiryDate: any;
  contactName: any;
  contactNo: any;
  isActive: any;
  userCount: any = 0;
  teamCount: any = 0;
  timeZone: any;
  isDataLoaded = false; // Spinner shows when false
  userListLoaded = false;
  teamListLoaded = false;
  inReportTypeClient :any;
   inPriorityClient :any;
   inTurnaroundTimeClient:any;
  isWebPageToggleEnabled: boolean = false;
  stReportTypesClient: any;
  flgIsEmailOnPublishClient: boolean = false;


  constructor(
    private _notificationService: NotificationService,
    private spinner: NgxSpinnerService,
    private _querystring: ActivatedRoute,
    private _clientService: ClientService,
    private _dataService: DatatransferService
  )
    {
      this.clientId = this._querystring.snapshot.paramMap.get('clientId') || '';
      this.listingBodyParameter = commonConstant.listingBodyParameter;
      this.listingBodyParameter.clientId = this.clientId;
      this.listingBodyParameter.stSortColumn = "stClient";
      this.timeZone =CommonFunction.GetTimeZone();
      this.listingBodyParameter.TimeZone = this.timeZone;
    }

  ngOnInit(): void {
    let isSetPassword = CommonFunction.isSetPasswordByUser();
    if (!isSetPassword) {
      window.location.href = 'setnewpassword';
    }
    this.spinner.show();
    this.getClientDetails();
    this._dataService.ViewPageCountsMessage.subscribe(countData => {
      if (countData != null || countData != "") {
        this.userCount = countData.users;
        this.teamCount = countData.teamCounts;
      }
    });
    if (document.querySelector('a[href="/clients"]') != null) {
      document.querySelector('a[href="/clients"]')?.setAttribute('class', 'active');
    }
  }

  ngOnDestroy() {
    if (document.querySelector('a[href="/clients"]') != null) {
      document.querySelector('a[href="/clients"]')?.setAttribute('class', '');
    }
  }
 // Called when UserList is loaded
 onUserListLoaded() {
  this.userListLoaded = true;
  this.checkAllLoaded();
}

// Called when TeamList is loaded
onTeamListLoaded() {
  this.teamListLoaded = true;
  this.checkAllLoaded();
}

// If both components are loaded, hide spinner
checkAllLoaded() {
  if (this.userListLoaded && this.teamListLoaded) {
    this.isDataLoaded = true;
  }
}
  getClientDetails() {
    this.isDataLoaded = false;
    this.spinner.show();
    let dt = {
     TimeZone: this.timeZone,
      clientId: this.clientId,

      stSearchText: "",
      stSortColumn: "stClient",
      stSortOrder: "",
      inOffset: 0,
      inLimit: 0
    };


    this._clientService.viewClient(dt).subscribe(
      {
        next:(response) => {
          if (!!response) {
            if (response.statusCode == 200) {
              this.clientResponse = response.data.resultSet;
              localStorage.setItem('ViewClienName', response.data.resultSet[0].client);
              this.clientName = response.data.resultSet[0].client;
              this.email = response.data.resultSet[0].email;
              this.expiryDate = response.data.resultSet[0].expiryDate;
              this.contactName = response.data.resultSet[0].contactName;
              this.contactNo = response.data.resultSet[0].contactNumber;
              this.isActive = response.data.resultSet[0].isActive;
              this.userCount = response.data.resultSet[0].users;
              this.teamCount = response.data.resultSet[0].teamCounts;
              this.inReportTypeClient = response.data.resultSet[0].inReportType;
              this.inPriorityClient = response.data.resultSet[0].inPriorityType;
              this.inTurnaroundTimeClient = response.data.resultSet[0].inTurnaroundTimeType;
              this.isWebPageToggleEnabled = response.data.resultSet[0].flgIsVisibleWebPage;
              localStorage.setItem('currentViewClientExpiryDate', this.expiryDate);
              localStorage.setItem('isClientActive',response.data.resultSet[0].isActive);
              this.monitoringFrequency = response.data.resultSet[0].monitoringFrequency == null ? "-" : response.data.resultSet[0].monitoringFrequency;
              this.paymentProfile = response.data.resultSet[0].paymentProfile == null ? "-" : response.data.resultSet[0].paymentProfile;
              this.stReportTypesClient = response.data.resultSet[0].stReportTypes;
              this.flgIsEmailOnPublishClient = response.data.resultSet[0].flgIsEmailOnPublish ?? false;
              this.spinner.hide();
              this.isDataLoaded = true;
            }
          }
        },
        error:  (error) => {
          this.spinner.hide();
          this.clientResponse = {
            resultSet: []
          };
          if (error != undefined) {
            if (error.status == 401) {
              this._notificationService.showInfo(commonConstant.expiredSessionErrorMessage, "Information");
            }
            else if (error.status == 0) {
              this._notificationService.showError(error.message, 'Error'); // unknown error
            } else if (error.status == 500) {
              this._notificationService.showError("Internal server error.", 'Error');
            }
          }
        }
      }
    );
  }

  // Update Client Information

  // CancelClientInfo(){
  //   (document.getElementById("monitoringFrequency") as HTMLInputElement).value = "";
  //   (document.getElementById('paymentProfile') as HTMLInputElement).value = "";
  // }

  // getPaymentProfileIdNamePairs(){
  //   this._clientService.getPaymentProfileIdNamePairs().subscribe(
  //     {
  //       next: (response : any) => {
  //         if (!!response) {
  //           if (response.statusCode == 200) {
  //             this.arrPaymentProfile = response.data;
  //             this.spinner.hide();
  //           }
  //         }
  //       },
  //       error:  (error: any) => {
  //         this.spinner.hide();
  //         if (error.status == 0) {
  //           this._notificationService.showError(error.message, "Error");
  //         }
  //         else if (error.status == 500) {
  //           this._notificationService.showError("Internal server error.", "Error"); // unknown error
  //         }
  //         else {
  //           this._notificationService.showError(error.error.errorMessage, "Error");
  //         }
  //       }
  //     }
  //    );
  // }

  // UpdateClientInfo(clientInfo: any){
  //   this.monitoringFrequency = (document.getElementById("monitoringFrequency") as HTMLInputElement)?.value;
  //   this.paymentProfile = (document.getElementById("paymentProfile") as HTMLInputElement)?.value;
  //   if(this.monitoringFrequency == "" || this.paymentProfile == ""){
  //     this.submitted = true;
  //     return;
  //   }
  //   //this.submitted = true;
  //   this.addEditClient.clientName = clientInfo[0].client;
  //   this.addEditClient.contactName = clientInfo[0].contactName;
  //   this.addEditClient.contactNo = clientInfo[0].contactNumber;
  //   this.addEditClient.email = clientInfo[0].email;
  //   this.addEditClient.clientExpiryDate = clientInfo[0].expiryDate; //this.clientForm.value.expiryDate;
  //   this.addEditClient.status = clientInfo[0].isActive;
  //   this.addEditClient.colorCode = clientInfo[0].colorCode;
  //   this.addEditClient.monitoringFrequency = this.monitoringFrequency;
  //   this.addEditClient.paymentProfile = this.paymentProfile;

  //   this._clientService.addEditClient(this.addEditClient, this.clientId).subscribe(
  //     {
  //       next: response => {
  //         if (!!response) {
  //           this._notificationService.showSuccess(response.message, "Success");
  //           this.spinner.hide();
  //           this.submitted = false;
  //         }
  //       },
  //       error:  (error) => {
  //         this.spinner.hide();
  //         this.submitted = false;
  //         if (error.status == 0) {
  //           this._notificationService.showError(error.message, "Error");
  //         }
  //         else if (error.status == 500) {
  //           this._notificationService.showError("Internal server error.", "Error"); // unknown error
  //         }
  //         else {
  //           this._notificationService.showError(error.error.errorMessage, "Error");
  //         }
  //       }
  //     }
  //    );
  // }

  switchClass(tab: string) : void{
    document.body.classList.remove('add-user-page', 'team-list-page');
    if (tab === 'Users') {
      document.body.classList.add('add-user-page');
    } else if (tab === 'Teams') {
      document.body.classList.add('team-list-page');
    }
  }

}